import { css } from "lit";

export default css`
  :host {
    font-size: var(--fp-font-size-base, 1em);
  }

  .cta {
    background-color: rgb(
      from var(--fp-cta-color-background, var(--fp-background-color)) r g b /
        alpha
    );
    color: rgb(
      from var(--fp-cta-color-text, var(--fp-text-color)) r g b / alpha
    );
    border-radius: 1.5em;
    padding: 1.5em 1.5em 1.5em 1.5em;
  }

  /* Modal */
  .fb-modal {
    --pu-color-overlay-background: var(
      --fp-overlay-background-color,
      rgb(0, 0, 0)
    );
    --pu-opacity-overlay-background: var(--fp-overlay-background-opacity, 0.2);
    position: fixed;
    z-index: 999999;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    pointer-events: none;
    bottom: 0;
    max-height: 100vh;
  }

  @media (max-width: 48em) {
    .fb-modal::part(content) {
      width: 100%;
    }
  }

  .modalContentBox {
    --pu-color-box-text: var(--fp-modal-text-color, rgb(17, 17, 17));
    --pu-color-box-background: var(
      --fp-modal-background-color,
      rgb(255, 255, 255)
    );
    --pu-space-modal-padding: 3.5em 0;
    position: relative;
    min-height: 100vh;
  }

  @media (min-width: 48.06em) {
    .modalContentBox {
      --pu-space-modal-padding: 6em;
      --pu-border-base-corner-radius: var(
        --fp-modal-corner-radius,
        var(--pu-border-radius-400, 0.75em)
      );
      border-radius: var(--pu-border-base-corner-radius);
      box-shadow: var(
        --fp-modal-shadow,
        0.25em 0.25em 1.25em rgba(0, 0, 0, 0.25)
      );
      min-height: auto;
      height: max-content;
    }
  }

  @media (min-width: 48.06em) {
    .modalContentBox::part(content) {
      padding: var(--fp-modal-padding, var(--pu-space-modal-padding));
      min-width: var(--fp-modal-min-width, 800px);
    }
  }
  @media (max-width: 48em) {
    .modalContentBox::part(content) {
      padding: var(--fp-modal-padding, var(--pu-space-modal-padding));
      min-height: 100svh;
    }
  }

  /* buttons */
  .button::part(button) {
    --pu-border-button-corner-radius: var(
      --fp-button-corner-radius,
      var(--pu-border-radius-200, 0.5em)
    );
    --pu-border-button-width: var(--fp-button-border-width, 0.0625em);
    --pu-color-button-border: rgb(
      from var(--fp-button-border-color, var(--fp-button-background-color)) r g
      b / alpha
    );
    --pu-color-button-outline: rgb(
      from var(--fp-button-outline-color, var(--fp-button-background-color)) r g
      b / alpha
    );
    --pu-size-button-height: var(--fp-button-height, 3.5em);
  }

  fp-login::part(button-link) {
    --pu-color-base-text-default: var(--fp-link-color);
    text-decoration-color: var(--fp-link-color);
  }

  .disconnect-button {
    --pu-size-button-height: 1em;
  }

  .button-icon {
    cursor: pointer;
    border: none;
    border-radius: var(
      --pu-border-icon-corner-radius,
      var(--pu-border-base-corner-radius, 0)
    );
    font-size: var(--pu-font-size-icon, 1.5em);
    padding: 0;
    color: var(--pu-color-icon-text, inherit);
    background-color: var(--pu-color-icon-background, inherit);
  }

  @supports (color: rgb(from white r g b)) {
    .button-icon {
      color: rgb(from var(--pu-color-icon-text, inherit) r g b / alpha);
      background-color: rgb(
        from var(--pu-color-icon-background, inherit) r g b / alpha
      );
    }
  }

  .button-icon > * {
    position: relative;
    display: block;
    padding: var(--pu-space-icon-padding, var(--pu-space-padding, 0.5em));
  }

  .button-icon:hover {
    opacity: 0.7;
  }

  .button-icon[disabled]:hover {
    opacity: 0.7;
  }

  /* loading spinner animation */
  .loading__spinner {
    animation-name: spin;
    animation-duration: 500ms;
    animation-timing-function: cubic-bezier(0, 0, 1, 1);
    animation-iteration-count: infinite;
    fill: currentcolor;
    color: var(--pu-color-base-text, rgb(160, 160, 160));
    height: 3em;
    width: 3em;
    left: 50%;
    top: 50%;
    margin: calc(var(--pu-space-400, 1em) / 2 * -1) 0 0
      calc(var(--pu-space-400, 1em) / 2 * -1);
  }
  @keyframes spin {
    to {
      transform: rotate(1turn);
    }
  }
`;
